export class GetTemplateList{
    static readonly type = '[Template] Get List'
    constructor(public plantName: string,public assetType: string,public plantId:string){}
  }